import { RightOutlined } from "@ant-design/icons";
import {

    Row,
    Col,

    Button,

    Form,
    Input,

    Select,

    Radio,

    Space,


} from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import accountService from "../../../api/account.service";
import { addPaymentMode } from "../../../store/paymentModeSlice";





import { EDIT_MODE, SUCCESS_STATUS } from "../../../utility/Constants";
import commonUtility from "../../../utility/Utils";
import CustomMessage from "../../common/CustomMessage";
const { Option } = Select;

const PaymentModeEntry = ( {onPaymentModeSaving,data , onDrawerClose} ) => {

    const dispatch = useDispatch();
    // console.log(data)
    const [isFormResponse, setIsFormResponse] = useState(false);
    const [formResponseMessage, setFormResponseMessage] = useState("");
    const [formResponseStatus, setFormResponseStatus] = useState("");

    const [accountList, setAccountList] = useState([]);

    const [formDefaultValues, setFormDefaultValues] = useState({
        id: data.id,
        payment_mode: data.payment_mode,
        account_id: data.account_id,
        mode: data.mode,
        is_bank_details: data.is_bank_details,
        bank_charges:data.bank_charges,
    });

    const [mode, setMode] = useState(data.mode);


    const [form] = Form.useForm();


    const onPaymentModeSave = async (values) => {
  
        const data = { formdata: values };
        const response = accountService.paymentModeSave(data).then((resdata) => {
            setIsFormResponse(true);
            setFormResponseStatus(resdata.response_status);
            setFormResponseMessage(resdata.response_msg);

            const x = {
                id:commonUtility.randomID(),
                payment_mode:values.payment_mode
            }
            dispatch(addPaymentMode(x))
           
        });
    };
 


    const hideResponseMessage = () => {
        setIsFormResponse(false);

        if(mode == "ADD") {
            form.resetFields();
            form.setFieldsValue({
                id: formDefaultValues.id,
                mode: data.mode
            })
        }

    }


    useEffect(() => {


        mode == EDIT_MODE ?

            form.setFieldsValue({



                id: formDefaultValues.id,
                payment_mode: formDefaultValues.payment_mode,
                account_id: formDefaultValues.account_id,
                mode: data.mode,
                is_bank_details: formDefaultValues.is_bank_details,
                bank_charges: formDefaultValues.bank_charges,

            })
            :
            form.setFieldsValue({
                id: 0,
                payment_mode: '',
                account_id: '',
                mode: data.mode,
                is_bank_details:data.is_bank_details,
                bank_charges:data.bank_charges,
            });


        form.setFieldsValue(formDefaultValues)

    }, [form]);




    useEffect(() => {
        accountService.accountList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setAccountList(res.data.response_data);
            }

        });
    }, []);




    return (
        <div>
            <div className="form-input-style">

                <Row className="" style={{ background: "transparent" }}>
                    <Col className="" xs={24} xl={24}>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onPaymentModeSave}
                            autoComplete="off"
                        // initialValues={formDefaultValues}
                        >

                            {/* <Row gutter={20}>
                         <Col className="gutter-row" xs={24} xl={24}>
                             <h5>Note: * fields are required</h5>
                         </Col>
                     </Row> */}
                            <Row gutter={20}>
                                <Col className="gutter-row" xs={24} xl={24}>

                                    <Form.Item name="payment_mode" label="Mode" rules={[
                                        {
                                            required: true,
                                            message: 'Payment mode is required',
                                        },
                                    ]}>
                                        <Input placeholder="" size="large" />
                                    </Form.Item>
                                    <Form.Item name="id" label="id" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                    <Form.Item name="mode" label="mode" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={24}>
                                    <Form.Item name="account_id" label="Account" rules={[
                                        {
                                            required: true,
                                            message: 'Account is required',
                                        },
                                    ]}>
                                        <Select className="text-left"
                                         showSearch
                                         placeholder="Search to Select"
                                         optionFilterProp="children"
                                         filterOption={(input, option) =>
                                             //option.children.includes(input)
                                             option.children.toLowerCase().includes(input.toLowerCase())
                                         }
                                         filterSort={(optionA, optionB) =>
                                             optionA.children
                                                 .toLowerCase()
                                                 .localeCompare(optionB.children.toLowerCase(), { sensitivity: 'base' })
                                         }
                                         placement="bottomLeft"
                                         allowClear={true}
                                        >
                                            
                                            {
                                                accountList.length > 0 ?
                                                    accountList.map(account_data => (
                                                        <Option key={account_data.id} value={account_data.id}>{account_data.account_name}</Option>

                                                    ))
                                                    : ''
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>

                                
                              <Col xs={24} xl={6}>
                                    <Form.Item name="bank_charges" label="Bank Charges in %" >
                                        <Input placeholder="" size="large" />
                                    </Form.Item>
                              </Col>

                              <Col xs={24} xl={12}>
                                  <Form.Item name="is_bank_details" label="Bank Details Required" >
                                      <Radio.Group
                                          
                                          style={{ width: "100%" }}
                                          optionType="button"
                                          buttonStyle="solid"
                                      >
                                          <Radio.Button value="Y">Yes</Radio.Button>
                                          <Radio.Button value="N">No</Radio.Button>
                                      </Radio.Group>
                                  </Form.Item>
                              </Col>







                                <Col xs={24} xl={24} align="right">
                                    <Form.Item name="" label=" ">
                                        <Space>

                                            <Button className="custom-button-green" htmlType="submit">
                                                Save <RightOutlined />
                                            </Button>
                                        </Space>
                                    </Form.Item>
                                </Col>


                            </Row>
                        </Form>



                    </Col>
                </Row>
                {
                    // isFormResponse ? <CustomMessage title={formResponseStatus} subtitle={formResponseMessage} action={hideResponseMessage} /> : ''
                    isFormResponse ? <CustomMessage title={formResponseStatus} subtitle={formResponseMessage} action={hideResponseMessage} onDrawerClose={onDrawerClose} mode={form.getFieldValue('mode')} /> : ''
                }




            </div>
        </div>
    );
}

export default PaymentModeEntry